/**
 * Utility for generating alert_id query strings
 * Used by alert components (Suricata, Notice, Yara, Anomaly) in this directory
 */

/**
 * Creates a standardized query string for alert_id term queries
 * @param alertId - The alert ID to query for
 * @returns Elasticsearch query string for alert_id term
 */
export function buildAlertIdQuery(alertId: string): string {
  return `{
    "query": {
      "bool": {
        "must": [
          {
            "term": {
              "alert_id": "${alertId}"
            }
          }
        ]
      }
    }
  }`;
}
